<template>
  <svg
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
    :class="svgClass"
    :style="svgStyle"
  >
    <path
      class="st0"
      d="M7.8,6.3c-2.3,0-2.3,3,0,3C10.1,9.3,10.1,6.3,7.8,6.3z M7.8,7.1c0.9,0,0.9,1.2,0,1.2S6.9,7.1,7.8,7.1z"
      :style="{'fill': fill}"
    />
    <polygon
      class="st0"
      points="11.4,6.4 6.6,13.1 8.1,13.1 12.9,6.4 "
      :style="{'fill': fill}"
    />
    <path
      class="st0"
      d="M11.8,10.1c-2.3,0-2.3,3,0,3C14,13.1,14,10.1,11.8,10.1z M11.8,12.2c-0.9,0-0.9-1.2,0-1.2
      C12.7,11,12.7,12.2,11.8,12.2z"
      :style="{'fill': fill}"
    />
    <path
      class="st0"
      d="M18.4,8.2l0.2-1.8c0.1-0.4-0.2-0.9-0.5-1.1l-1.6-1c-0.2-0.1-0.3-0.3-0.4-0.5l-0.8-1.7c-0.2-0.4-0.6-0.7-1.1-0.7
      l-1.8,0c-0.2,0-0.4-0.1-0.6-0.2l-1.6-1C9.9,0.1,9.4,0.1,9,0.4l-1.5,1C7.3,1.5,7.1,1.6,6.9,1.6L5,1.6c-0.4,0-0.9,0.3-1,0.7L3.3,4
      C3.2,4.2,3,4.4,2.8,4.5l-1.5,1C0.9,5.7,0.7,6.2,0.8,6.6l0.3,1.8c0,0.2,0,0.4-0.1,0.6l-0.7,1.7c-0.2,0.4-0.1,0.9,0.2,1.2l1.2,1.4
      C1.9,13.5,2,13.7,2,13.9l0.3,1.8c0.1,0.4,0.4,0.8,0.8,0.9l1.8,0.5c0.2,0.1,0.4,0.2,0.5,0.3l1.2,1.4c0.3,0.3,0.8,0.5,1.2,0.3l1.8-0.5
      c0.2-0.1,0.4-0.1,0.6,0l1.8,0.5c0.4,0.1,0.9,0,1.2-0.4l1.2-1.4c0.1-0.2,0.3-0.3,0.5-0.4l1.8-0.5c0.4-0.1,0.7-0.5,0.8-0.9l0.2-1.8
      c0-0.2,0.1-0.4,0.3-0.6l1.2-1.4c0.3-0.3,0.3-0.8,0.2-1.2l-0.8-1.7C18.4,8.6,18.3,8.4,18.4,8.2z M17,12.7l-0.2,0.2l0,0.3l-0.2,1.5
      c-0.1,0.4-0.4,0.8-0.8,0.9l-1.5,0.5L14,16.2l-0.2,0.2l-1,1.2c-0.3,0.3-0.7,0.5-1.2,0.4l-1.5-0.4l-0.3-0.1l-0.3,0.1l-1.5,0.5
      c-0.4,0.1-0.9,0-1.2-0.3l-1-1.1l-0.2-0.2l-0.3-0.1L4,15.9c-0.4-0.1-0.8-0.5-0.8-0.9l-0.2-1.5l0-0.3l-0.2-0.2l-1-1.1
      c-0.3-0.3-0.4-0.8-0.2-1.2l0.6-1.4l0.1-0.3l0-0.3L1.9,7.1C1.8,6.7,2,6.2,2.4,6l1.3-0.9L3.9,5L4,4.7l0.6-1.4c0.2-0.4,0.6-0.7,1-0.7
      l1.5,0l0.3,0l0.2-0.2L9,1.6c0.4-0.2,0.9-0.3,1.2,0l1.3,0.8l0.2,0.2l0.3,0l1.5,0c0.4,0,0.9,0.2,1.1,0.7l0.7,1.4l0.1,0.3l0.2,0.2
      L17,5.7c0.4,0.2,0.6,0.7,0.5,1.1l-0.2,1.5l0,0.3l0.1,0.3l0.7,1.4c0.2,0.4,0.1,0.9-0.2,1.2L17,12.7z"
      :style="{'fill': fill}"
    />
  </svg>
</template>

<script>
export default {
  components: {},
  props: {
    viewBox: { type: String, default: '0 0 23.6 19' },
    fill: { type: String, default: '#FFFFFF' },
    svgClass: { type: String, default: 'svg-icon' },
    svgStyle: { type: Object },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
